import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';
import { dataIntervalExport } from '../params';
import { postApi } from '../../lib/fetcher';

const reportBpjstk = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      item: null,
      itemLoading: false,
      intervalExport: 0,
      exportId: null,
      ceountDataExport: 0,
      totalPage: 0,
      requestData: null,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },
    setItem(state, { payload }) {
      state.item = payload?.data?.data ?? payload?.data ?? null;
    },

    setItemLoading(state, loading) {
      state.itemLoading = loading;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },
    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },

    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },

    setCancelation(state, payload) {
      state.requestData = payload;
    },
  },

  actions: {
    async getData(
      ctx,
      { date, page, itemsPerPage, search, source }
    ) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by: 'trx_datetime DESC',
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlControll =
        source == 'ch'
          ? 'report/report-bpjs-ch/index'
          : 'report/report-bpjs/index';

      const urlApi = `/index.php?r=api/v1/${urlControll}`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async viewDetail(ctx, { date, id }) {
      ctx.commit('setItem', { payload: null });
      ctx.commit('setItemLoading', true);

      const data = JSON.stringify({
        id: id.toString(),
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/report/report-bpjs/view`;

      try {
        const responseData = await postApi(ctx, urlApi, data);

        if (responseData?.code == 200) {
          ctx.commit('setItem', { payload: responseData });
          return true;
        }
        return false;
      } catch (error) {
        return false;
      } finally {
        ctx.commit('setItemLoading', false);
      }
    },

    async exportList(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      if (ctx.rootState.isExport) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export in progress !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        return;
      }

      ctx.commit('setLoading', true);
      ctx.commit('setIsExport', true, { root: true });
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'countSameExport',
      });
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
        ctx.commit('setIsExport', false, { root: true });
      };

      try {
        const urlApi = `/index.php?r=api/v1/export/export-transaction-bpjstk`;

        const responseData = await postApi(ctx, urlApi, data);

        if (responseData?.code == 200) {
          if (responseData.data.message != null) {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: responseData.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
            ctx.commit('setIsExport', false, { root: true });
            return;
          }
          ctx.commit('setExportData', responseData.data);
          const interval = setInterval(() => {
            ctx.dispatch(
              'exportStatus',
              {
                date,
                exportId: ctx.state.exportId,
                countDataExport: ctx.state.countDataExport,
                controller: 'export-transaction',
              },
              { root: true }
            );
          }, dataIntervalExport);
          ctx.commit('setIntervalExport', interval, { root: true });
          ctx.commit(
            'setInsertProgressGlobal',
            {
              absoluteBar: true,
              absoluteBarText: 'Start to export data..',
            },
            { root: true }
          );
        } else {
          failed();
        }
      } catch (error) {
        failed();
      }
    },
  },
};
export default reportBpjstk;
